import { useContext, useEffect } from "react";
import EditableFeaturesList from "../EditFeatures/EditableFeaturesList";
import { EditorContext } from "../EditorContextProvider";

const EntryPointsList = ({
  editableLayers,
  handleNext,
  handleClick,
  editType,
  layers,
}) => {
  const { setEditableLayer, editableLayer, updateType } =
    useContext(EditorContext);

  useEffect(() => {
    if (!editableLayer && layers.length > 0) {
      setEditableLayer(layers[0]);
    }
  }, []);

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          overflow: "hidden",
          position: "relative",
        }}
      >
        {editableLayer && (
          <EditableFeaturesList
            editableLayer={editableLayer}
            handleSelectFeature={handleClick}
            handleNext={handleNext}
            editableLayers={editableLayers}
            editType={editType}
            isEntryPoints
          />
        )}
      </div>
    </div>
  );
};

export default EntryPointsList;
